import { ERROR_CODE }              from '../00_assets'
import { CodeError
       , CTE
       , DEBUG }                   from '../01_core'

import { connect_t }               from './01_api_types'
import { auth_token
       , logout }                  from './02_api_auth'


declare type call_opts_t = { credentials?: boolean } ;


let   HOST = 'https://kde.jma.es' ;
let   API_PATH = '/api/' ;
// TODO VERSION:
// const version = 1 ;


export function enable_api_debug ( )
{
  HOST = 'https://localhost:8443' ;
}



export function post ( url : string, data: object | any[], call_opts: call_opts_t = { } )
{
  return connect( path( url )
                , { method: 'POST'
                  , headers: { 'content-type': 'application/json' }
                  , body: JSON.stringify( data ) }
                , call_opts ) ;
}


export async function connect ( url: string
                              , opts: RequestInit = { }
                              , auth_opts: call_opts_t = { } 
                              ): Promise< connect_t >
{
  const token = auth_token( ) ;

  if ( token && auth_opts.credentials )
    {
       if ( !opts.headers )
            opts.headers = {} ;

       (opts.headers as any)[ 'Authorization' ] = 'Bearer ' + token ;
    }

  DEBUG.msg( CTE.DEBUG.INFO, 'Conectando', url, opts ) ;

  try
  {
    const response = await fetch( url, opts ) ;

    if ( response.status === ERROR_CODE.NONE )
        try { return await response.json( ) ; }
        catch ( _error ) { return {} as any ; }

    if ( response.status === ERROR_CODE.TOKEN_EXPIRED )
        logout( ) ;

    throw new CodeError( response.status ) ;
  }
  catch ( error )
  {
    console.error( 'fetch error', error ) ;
    throw error ;
  }
}




export function form_post ( url : string, body: FormData, call_opts: call_opts_t = { } )
{
  return connect( path( url )
                , { method: 'POST'
                  , body }
                , call_opts ) ;
}


export function form_data ( data: any )
{
  const fd = new FormData( )
      , is_string = ( val: any ) => (typeof val === 'string') ;

  for ( let key in data )
     {
        const value    = data[ key ] ;
//            , filename = value instanceof File? value.name : false ;

        if ( value instanceof File )
        {
                 console.log( 'lo intentamos', key, value ) ;

             fd.append( key, value, value.name ) ;
        }
        else
             fd.append( key, is_string( value )? value: JSON.stringify( value ) ) ;
     }

  return fd ;
}


export function path ( postfix : string = '' ) : string
{
  return HOST + API_PATH + postfix ;
}


export function put ( url : string, data: object | any[], call_opts: call_opts_t = { } )
{
  return connect( path( url )
                , { method: 'PUT'
                  , headers: { 'content-type': 'application/json' }
                  , body: JSON.stringify( data ) }
                , call_opts ) ;
}


export async function get ( url : string, data: any = {}, call_opts: call_opts_t = { } )
{
  return connect( path( add_url_get_args( url, data ) )
                , { method: 'GET' }
                , call_opts ) ;
}


function add_url_get_args ( url : string, data: any = {} ) : string
{
  const args: string[] = [ ]
      , has_args = url.indexOf( '?' ) !== -1 ;

  for ( const key in data )
        if ( data.hasOwnProperty( key ) )
             args.push( key + '=' + encodeURIComponent( data[ key ] as any ) ) ;

  return url + (args.length? (has_args?'&':'?') + args.join( '&' ) : '') ;
}


export function del ( url : string, call_opts: call_opts_t = { } )
{
  return connect( path( url )
                , { method: 'DELETE' }
                , call_opts ) ;
}
